import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchApi } from '../utils/api';

function CategoryView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [stratagems, setStratagems] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [categoryData, stratagemsData] = await Promise.all([
          fetchApi(`/categories/${id}`),
          fetchApi(`/categories/${id}/stratagems`)
        ]);
        setCategory(categoryData);
        setStratagems(stratagemsData);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    loadData();
  }, [id]);

  const handleStratagemClick = (stratagemId) => {
    navigate(`/stratagem/${stratagemId}`);
  };

  if (loading) return <div className="section"><p className="subtitle">Loading stratagems...</p></div>;
  if (error) return <div className="section"><p className="subtitle has-text-danger">Error: {error}</p></div>;
  if (!category || !stratagems || stratagems.length === 0) return <div className="section"><p className="subtitle">No stratagems found</p></div>;

  return (
    <div className="section">
      <button className="button is-link mb-4" onClick={() => navigate('/')}>
        Back to Categories
      </button>
      <h2 className="title is-2 mb-4">Stratagems for {category.name}</h2>
      <div className="columns is-multiline">
        {stratagems.map(stratagem => (
          <div key={stratagem.id} className="column is-one-third">
            <div className="card speech-bubble" onClick={() => handleStratagemClick(stratagem.id)}>
              <div className="card-content">
                <p className="title is-4">{stratagem.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoryView; 